import React, { Component } from 'react';
import { merge, get } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { fetchBrand, updateBrandForm } from 'services/brands/duck';
import { push } from 'connected-react-router';
import { getDefaultEnabledChannels } from 'helpers/channels';
import EditBrandForm from 'components/organisms/forms/EditBrand';

class EditBrandContainer extends Component {
    componentDidMount() {
        const brandId = this.props.match.params.id;

        if (this.props.fetchBrand && brandId) {
            this.props.fetchBrand({ brandId });
        }
    }

    render() {
        const brandId = get(this.props, 'match.params.id');
        return (
            <EditBrandForm
                brand={this.props.brand}
                handleSubmit={this.props.handleSubmit.bind(null, updateBrandForm)}
                currentUser={this.props.currentUser}
                cancel={() => this.props.push(`/admin/brands${brandId ? `/${brandId}` : ''}`)} >
                {this.props.children}
            </EditBrandForm>
        );
    }
}

const mapStateToProps = state => ({
    brand: state.brands.brand,
    initialValues: merge({ meta: { channelConfig: getDefaultEnabledChannels() } }, state.brands.brand),
    currentUser: state.users.currentUser
});

export default compose(
    connect(mapStateToProps, { fetchBrand, push }),
    reduxForm({
        form: 'editBrand',
        enableReinitialize: true
    })
)(EditBrandContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/brands/EditBrandContainer.js